<template>
  <div
    class="feature-image-text flex flex-col-reverse md:items-center"
    :class="reverse ? 'md:flex-row-reverse' : 'md:flex-row'"
  >
    <img :src="image" class="image flex-auto p-6 md:w-1/2" />
    <div class="text-block text-center flex-auto p-4 md:w-1/2 md:text-left">
      <TypeDisplay
        :variant="$options.Typography.Display.GIGA"
        :weight="$options.Typography.Weights.STRONG"
        tag="p"
      >
        {{ title }}
      </TypeDisplay>
      <TypeHeading
        :variant="$options.Typography.Heading.SUBTITLE"
        :weight="$options.Typography.Weights.REGULAR"
      >
        {{ subtitle }}
      </TypeHeading>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { TypeDisplay, TypeHeading, constants } from '@bambeehr/pollen';
const { Typography } = constants;

export default defineComponent({
  name: 'FeatureImageText',
  Typography,
  components: { TypeDisplay, TypeHeading },
  props: {
    image: { type: String, default: '' },
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    reverse: { type: Boolean, default: false },
  },
});
</script>
